@if (canDisplay$ | async) {
  <span
    class="indicator accent-color"
    i18n-matTooltip
    matTooltip="Unsaved changes to shipment are pending">
    •
  </span>
}
